import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  useMediaQuery,
  Divider,
} from "@mui/material";
import {
  FaChartBar,
  FaSchool,
  FaMoneyBill,
  FaUsersCog,
  FaSignOutAlt,
} from "react-icons/fa";
import { MdAccountBalance } from "react-icons/md";
const DRAWER_WIDTH = 260;
const MINI_WIDTH = 0;

export default function SuperAdminSidebar({ open = true, setOpen = () => { } }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:900px)");

  useEffect(() => {
    try {
      localStorage.setItem("super_sidebar_open", open ? "1" : "0");
    } catch (e) { }
  }, [open]);

  const sections = [
    {
      title: "Overview",
      items: [
        { key: "dashboard", label: "Dashboard", icon: <FaChartBar />, to: "/super_admin/dashboard" },
      ],
    },
    {
      title: "Management",
      items: [
        {
          key: "schools",
          label: "Schools",
          icon: <FaSchool />,
          to: "/super_admin/schools",
        },
          {
          key: "accounts-expense",
          label: "Accounts & Expense",
          icon: <MdAccountBalance />,
          to: "/super_admin/accounts-expense",
        },
        {
          key: "subscriptions",
          label: "Subscriptions",
          icon: <FaMoneyBill />,
          to: "/super_admin/subscriptions",
        },
        {
          key: "admins",
          label: "Admins & Staff",
          icon: <FaUsersCog />,
          to: "/super_admin/schooladmins",
        },
      
      ],
    },
  ];

  const handleNavigate = (to) => {
    if (isMobile) setOpen(false);
    if (to) navigate(to);
  };

  return (
    <Box component="nav" sx={{ width: open ? DRAWER_WIDTH : MINI_WIDTH, flexShrink: 0 }}>
      <Drawer
        variant="persistent"
        open={open}
        sx={{
          "& .MuiDrawer-paper": {
            width: open ? DRAWER_WIDTH : MINI_WIDTH,
            transition: "width 0.3s ease",
            overflowX: "hidden",
            bgcolor: "#102a43",
            color: "white",
            borderRight: 0,
            background:
              "linear-gradient(180deg, #0b2540 0%, #123a5a 46%, #0f766e 100%)",
            borderTop: "3px solid #0891b2",
            boxShadow: "18px 0 46px rgba(16,42,67,0.24)",
          },
        }}
      >
        <Toolbar sx={{ justifyContent: "center" }}>
          {open ? (
            <Typography sx={{ fontWeight: 900, fontSize: 18, letterSpacing: 0 }}>
              Platform Admin
            </Typography>
          ) : (
            "PA"
          )}
        </Toolbar>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.1)" }} />

        <List sx={{ p: 1 }}>
          {sections.map((section, idx) => (
            <Box key={section.title} sx={{ mb: 2 }}>
              {open && (
                <Typography
                  sx={{
                    px: 1.25,
                    py: 0.5,
                    fontSize: 12,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    color: "rgba(255,255,255,0.6)",
                  }}
                >
                  {section.title}
                </Typography>
              )}

              {section.items.map((m) => {
                const active = location.pathname === m.to;
                return (
                  <ListItemButton
                    key={m.key}
                    onClick={() => handleNavigate(m.to)}
                    sx={{
                      mb: 0.5,
                      borderRadius: 1.5,
                      py: 1.1,
                      px: 1.25,
                      bgcolor: active ? "rgba(125,211,252,0.22)" : "transparent",
                      boxShadow: active ? "inset 4px 0 0 #7dd3fc, 0 8px 18px rgba(4,22,40,0.16)" : "none",
                      transition: "transform .2s ease, background .2s ease, box-shadow .2s ease",
                      "&:hover": {
                        transform: "translateX(4px)",
                        bgcolor: "rgba(255,255,255,0.1)",
                      },
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 44 }}>
                      <Box
                        sx={{
                          width: 36,
                          height: 36,
                          borderRadius: 1,
                          display: "grid",
                          placeItems: "center",
                          bgcolor: active ? "rgba(125,211,252,0.24)" : "rgba(255,255,255,0.08)",
                          color: "white",
                          fontSize: 18,
                        }}
                      >
                        {m.icon}
                      </Box>
                    </ListItemIcon>

                    {open && (
                      <ListItemText
                        primary={m.label}
                        primaryTypographyProps={{
                          sx: { fontWeight: active ? 800 : 600, fontSize: 14 },
                        }}
                      />
                    )}
                  </ListItemButton>
                );
              })}

              {idx < sections.length - 1 && open && (
                <Divider sx={{ borderColor: "rgba(255,255,255,0.05)", mt: 1 }} />
              )}
            </Box>
          ))}

          <Box sx={{ mt: 2 }}>
            <ListItemButton
              onClick={() => {
                localStorage.clear();
                navigate("/super_admin/login");
              }}
              sx={{
                borderRadius: 1.5,
                py: 1,
                px: 1.25,
                "&:hover": {
                  bgcolor: "rgba(255,255,255,0.08)",
                  transform: "translateX(4px)",
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 44 }}>
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: 1,
                    display: "grid",
                    placeItems: "center",
                    bgcolor: "rgba(255,255,255,0.08)",
                    color: "white",
                  }}
                >
                  <FaSignOutAlt />
                </Box>
              </ListItemIcon>
              {open && <ListItemText primary="Logout" />}
            </ListItemButton>
          </Box>
        </List>
      </Drawer>
    </Box>
  );
}
